import { AppError } from "../../../shared/utils/error-handler";
import type {
  ProductLightDto,
} from "../../types/shop";
import type { ShopProductRepository } from "../../repositories/shop/shop-product-repository";
import type {
  ProductEntity,
  ShopProduct,
  ShopProductDetail,
  ProductOptionResponse,
  ProductOptionRequest,
  CalculatePriceResponse,
} from "../../types/shop-product";

export class ShopProductUsecase {
  constructor(private shopProductRepository: ShopProductRepository) {}

  async getBestsellerList(shopId: number): Promise<ProductLightDto[]> {
    try {
      return await this.shopProductRepository.getBestsellerList(shopId);
    } catch (error) {
      throw new AppError(
        String(error) || "베스트셀러 목록을 불러오지 못했습니다.",
        "BEST_SELLER_LIST_GET_FAILED",
        error,
      );
    }
  }

  async getRecentlyViewedProducts(shopId: number): Promise<ProductEntity[]> {
    try {
      return await this.shopProductRepository.getRecentlyViewedProducts(shopId);
    } catch (error) {
      throw new AppError(
        String(error) || "최근 둘러본 상품을 불러오지 못했습니다.",
        "RECENTLY_VIEWED_PRODUCTS_GET_FAILED",
        error,
      );
    }
  }

  async getProductList(shopId: number): Promise<ProductLightDto[]> {
    try {
      return await this.shopProductRepository.getProductList(shopId);
    } catch (error) {
      throw new AppError(
        String(error) || "전체 상품 목록을 불러오지 못했습니다.",
        "PRODUCT_LIST_GET_FAILED",
        error,
      );
    }
  }
  
  async getProducts(shopId: number): Promise<ShopProduct[]> {
    try {
      return await this.shopProductRepository.getProducts(shopId);
    } catch (error) {
      throw new AppError(
        String(error) || "상품 목록을 불러오지 못했습니다.",
        "SHOP_PRODUCT_LIST_FAILED",
        error
      );
    }
  }

  async getProductDetail(shopId: number, productId: number): Promise<ShopProductDetail> {
    try {
      return await this.shopProductRepository.getProductDetail(shopId, productId);
    } catch (error) {
      throw new AppError(
        String(error) || "상품 정보를 불러오지 못했습니다.",
        "SHOP_PRODUCT_DETAIL_FAILED",
        error
      );
    }
  }

  async getProductOptions(
    shopId: number,
    productId: number,
    request?: ProductOptionRequest
  ): Promise<ProductOptionResponse> {
    try {
      return await this.shopProductRepository.getProductOptions(shopId, productId, request);
    } catch (error) {
      throw new AppError(
        String(error) || "옵션 정보를 불러오지 못했습니다.",
        "SHOP_PRODUCT_OPTION_FAILED",
        error
      );
    }
  }

  async calculatePrice(
    shopId: number,
    productId: number,
    request: ProductOptionRequest
  ): Promise<CalculatePriceResponse> {
    try {
      return await this.shopProductRepository.calculatePrice(shopId, productId, request);
    } catch (error) {
      throw new AppError(
        String(error) || "가격 계산에 실패했습니다.",
        "SHOP_PRODUCT_CALCULATE_FAILED",
        error
      );
    }
  }
}
